<template>
  <div class="px-5 py-7 bg-custom">
    <v-form ref="form" v-model="valid">
      <!-- BASIC INFORMATION SECTION -->
      <v-row>
        <v-col :xl="6" :lg="6" :md="6" :sm="12" cols="12">
          <v-row>
            <!-- COMPANY NAME -->
            <v-col :lg="12" :md="12" :sm="12" cols="12">
              <p class="font-weight-light mb-2">
                Company's Name <span class="red--text">*</span>
              </p>
              <v-text-field
                v-model="item.title"
                value="``"
                :rules="companyNameRules"
                placeholder="Company's Name"
                required
                clearable
                clear-icon="mdi-close mb-2"
                solo
                dense
                flat
                class="text-field-border"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="12" :md="12" :sm="12" cols="12">
              <p class="font-weight-light mb-2">
                External Access <span class="red--text">*</span>
              </p>
              <v-radio-group v-model="item.externalAccess" column class="pl-4">
                <v-radio :value="false">
                  <template v-slot:label>
                    <div>
                      <strong class="dark--text">No.</strong>
                      <span class="grey--text text--lighten-1 body-2"
                        >(คนนอกองค์กรไม่สามารถเข้าถึงได้)</span
                      >
                    </div>
                  </template>
                </v-radio>
                <v-radio :value="true">
                  <template v-slot:label>
                    <div>
                      <strong class="dark--text">Yes.</strong>
                      <span class="grey--text text--lighten-1 body-2"
                        >(คนนอกองค์กรสามารถเข้าถึงได้)</span
                      >
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <!-- DESCRIPTION -->
        <v-col :xl="6" :lg="6" :md="6" :sm="12" cols="12">
          <p class="font-weight-light my-2">
            Description <span class="red--text">*</span>
          </p>
          <quill-editor
            class="editor mx-2"
            v-model="item.description"
            ref="description"
            :rules="descriptionRules"
          />
        </v-col>
      </v-row>
      <!-- CONTACT EMAIL -->
      <v-row class="mt-10">
        <v-col :lg="6" :md="6" :sm="12" cols="12">
          <p class="font-weight-light mb-2">
            Contact Email <span class="red--text">*</span>
          </p>
          <v-text-field
            v-model="item.contactEmail"
            :rules="emailRules"
            :counter="50"
            placeholder="Contact Email"
            clearable
            clear-icon="mdi-close mb-2"
            solo
            dense
            flat
            class="text-field-border"
          ></v-text-field>
        </v-col>
        <v-col :lg="6" :md="6" :sm="12" cols="12">
          <p class="font-weight-light mb-2">
            Sub Domain Name <span class="red--text">*</span>
          </p>
          <v-text-field
            v-model="item.domainName"
            placeholder="Sub Domain Name"
            :rules="domainNameRule"
            required
            clearable
            clear-icon="mdi-close mb-2"
            solo
            dense
            flat
            class="text-field-border"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- SYSTEM EMAIL -->
      <v-row class>
        <v-col :lg="6" :md="6" :sm="12" cols="12">
          <p class="font-weight-light mb-2">
            System Email <span class="red--text">*</span>
            <span class="font-weight-light my-0 ml-5">(ใช้สำหรับ login)</span>
          </p>
          <v-text-field
            v-model="item.systemEmail"
            :counter="50"
            :rules="emailRules"
            placeholder="System Email"
            required
            clearable
            clear-icon="mdi-close mb-2"
            solo
            dense
            flat
            class="text-field-border"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider class="mt-12 mb-3"></v-divider>
      <!-- limitation -->
      <v-row>
        <v-col>
          <p class="title font-weight-black">Limitation</p>
        </v-col>
      </v-row>
      <!-- KEY ICON-->
      <v-row>
        <v-col :xl="6" :lg="6" :md="6" :sm="12" cols="12">
          <v-row>
            <v-col :lg="12" :md="12" :sm="12" cols="12">
              <p class="font-weight-light mb-2">
                Allow user registration <span class="red--text">*</span>
              </p>
              <v-radio-group v-model="item.register.canRegister" column class="pl-4">
                <v-radio :value="false">
                  <template v-slot:label>
                    <div>
                      <strong class="dark--text">No.</strong>
                      <span class="grey--text text--lighten-1 body-2"
                        >(ผู้ใช้ไม่สามารถลงทะเบียนด้วยตนเองได้)</span
                      >
                    </div>
                  </template>
                </v-radio>
                <v-radio :value="true">
                  <template v-slot:label>
                    <div>
                      <strong class="dark--text">Yes.</strong>
                      <span class="grey--text text--lighten-1 body-2"
                        >(ผู้ใช้สามารถลงทะเบียนด้วยตนเองได้)</span
                      >
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col :xl="6" :lg="6" :md="6" :sm="12" cols="12">
              <v-row v-if="item.register.canRegister">
                <v-col :lg="12" :md="12" :sm="12" cols="12">
                  <p class="font-weight-light mb-2">Register Option</p>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-checkbox
                        label="Email"
                        class="my-0 py-0 pl-4"
                        v-model="item.register.loginEmail"
                        disabled
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col :xl="6" :lg="6" :md="6" :sm="12" cols="12">
          <v-row>
            <v-col :lg="12" :md="12" :sm="12" cols="12">
              <p class="font-weight-light mb-2">
                Course Limit <span class="red--text">*</span>
              </p>
              <v-radio-group v-model="item.course.courseLimitation" column class="pl-4">
                <v-radio :value="false">
                  <template v-slot:label>
                    <div>
                      <strong class="dark--text">No Limit.</strong>
                    </div>
                  </template>
                </v-radio>
                <v-radio :value="true">
                  <template v-slot:label>
                    <div>
                      <strong class="dark--text">Limit with</strong>
                    </div>
                    <v-col cols="4">
                      <v-text-field
                        v-model="item.course.courseLimit"
                        type="number"
                        placeholder="0"
                        class="text-field-border"
                        :disabled="!item.course.courseLimitation"
                        min="0"
                        solo
                        dense
                        flat
                      ></v-text-field> </v-col
                    >Items.
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
        <v-col :xl="6" :lg="6" :md="6" :sm="12" cols="12">
          <v-row>
            <v-col :lg="12" :md="12" :sm="12" cols="12">
              <p class="font-weight-light mb-2">
                User Limit <span class="red--text">*</span>
              </p>
              <v-radio-group v-model="item.user.userLimitation" column class="pl-4">
                <v-radio :value="false">
                  <template v-slot:label>
                    <div>
                      <strong class="dark--text">No Limit.</strong>
                    </div>
                  </template>
                </v-radio>
                <v-radio :value="true">
                  <template v-slot:label>
                    <div>
                      <strong class="dark--text">Limit with</strong>
                    </div>
                    <v-col cols="4">
                      <v-text-field
                        v-model="item.user.userLimit"
                        type="number"
                        placeholder="0"
                        class="text-field-border"
                        solo
                        dense
                        flat
                        :disabled="!item.user.userLimitation"
                        min="0"
                      ></v-text-field> </v-col
                    >persons.
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col :xl="6" :lg="6" :md="6" :sm="12" cols="12">
          <v-row>
            <v-col :lg="12" :md="12" :sm="12" cols="12">
              <p class="font-weight-light mb-2">
                Storage Space Limit <span class="red--text">*</span>
              </p>
              <v-radio-group v-model="item.storage.storageLimitation" column class="pl-4">
                <v-radio :value="false">
                  <template v-slot:label>
                    <div>
                      <strong class="dark--text">No Limit.</strong>
                    </div>
                  </template>
                </v-radio>
                <v-radio :value="true">
                  <template v-slot:label>
                    <div>
                      <strong class="dark--text">Limit with</strong>
                    </div>
                    <v-col cols="4">
                      <v-text-field
                        v-model="item.storage.storageLimit"
                        type="number"
                        placeholder="0"
                        class="text-field-border"
                        solo
                        dense
                        flat
                        :disabled="!item.storage.storageLimitation"
                        min="0"
                      ></v-text-field> </v-col
                    >MB.
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-5"></v-divider>
      <!-- CUSTOMIZE PHOTO SECTION -->
      <v-row>
        <v-col>
          <p class="title font-weight-black">Customize Photo</p>
        </v-col>
      </v-row>
      <!-- KEY ICON-->
      <v-row>
        <v-col lg="6" md="6" sm="12" cols="12">
          <p class="font-weight-light mb-2">Key Icon <span class="red--text">*</span></p>
          <v-text-field
            v-model="item.keyIcon"
            solo
            dense
            flat
            placeholder="Key Icon"
            :rules="keyIconRules"
            clearable
            clear-icon="mdi-close mb-2"
            class="text-field-border"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <p class="font-weight-light mb-0">
            Cover Image <span class="red--text">*</span>
          </p>
        </v-col>
      </v-row>
      <v-row>
        <!-- COVER PHOTO -->
        <v-col lg="6" md="6" sm="6" cols="12">
          <div v-if="coverImgReady" class="image-preview border-card">
            <v-img contain :src="item.coverImg" width="100%">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
          <div v-if="!coverImgReady" class="image-preview border-card"></div>
        </v-col>
        <v-col lg="6" md="6" sm="6" cols="12">
          <div class="upload-btn-wrapper">
            <button class="btn-choose body-1 font-weight-medium">
              <v-icon>mdi-upload</v-icon>Choose file
            </button>
            <input
              type="file"
              name="myfile"
              :rules="imageRules"
              @change="previewCoverImg"
              accept="image/png, image/jpeg, image/bmp"
            />
          </div>
          <p class="mb-0 text-custom body-2 font-weight-regular">
            Acceptable formats：.png .jpg only
          </p>
          <p class="mb-0 text-custom body-2 font-weight-regular">Max file size is 1MB</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pb-0">
          <p class="font-weight-light mb-0">
            Logo Image <span class="red--text">*</span>
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="3" md="3" sm="3" cols="12">
          <div v-if="logoReady" class="image-preview border-card">
            <v-img contain :src="item.logo" width="100%">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
        </v-col>
        <v-col lg="3" md="3" sm="3" cols="12">
          <div class="upload-btn-wrapper">
            <button class="btn-choose body-1 font-weight-medium">
              <v-icon>mdi-upload</v-icon>Choose file
            </button>
            <input
              type="file"
              name="myfile"
              :rules="imageRules"
              @change="previewLogo"
              accept="image/png, image/jpeg, image/bmp"
            />
          </div>
          <p class="mb-0 text-custom body-2 font-weight-regular">
            Acceptable formats：.png .jpg only
          </p>
          <p class="mb-0 text-custom body-2 font-weight-regular">Max file size is 1MB</p>
        </v-col>
      </v-row>
      <v-divider class="my-5"></v-divider>
      <!-- CUSTOMIZE COLOR SECTION -->
      <v-row>
        <v-col>
          <p class="title font-weight-black">Customize Color</p>
        </v-col>
      </v-row>
      <!-- COLOR PICKER DIALOG -->
      <v-row class="mb-10">
        <colorButton
          v-bind:color_title="`Header Color`"
          v-bind:color_type="`header`"
          v-bind:color="headerColor"
          @isClick="showColorChart"
        ></colorButton>

        <colorButton
          v-bind:color_title="`Footer Color`"
          v-bind:color_type="`footer`"
          v-bind:color="footerColor"
          @isClick="showColorChart"
        ></colorButton>

        <colorButton
          v-bind:color_title="`Button Color`"
          v-bind:color_type="`button`"
          v-bind:color="buttonColor"
          @isClick="showColorChart"
        ></colorButton>

        <colorButton
          v-bind:color_title="`Overall Color`"
          v-bind:color_type="`overall`"
          v-bind:color="overallColor"
          @isClick="showColorChart"
        ></colorButton>
      </v-row>

      <warnningComponent
        v-bind:textInfo.sync="textWarning"
        v-bind:typestatus.sync="typeWarning"
        v-bind:alert.sync="showWarnnig"
      ></warnningComponent>

      <v-row>
        <v-col>
          <div class="my-2 float-right">
            <v-btn class="mr-3 pl-10 pr-10" @click="showCompanyList" outlined large
              >Cancel</v-btn
            >
            <v-btn
              class="pl-10 pr-10"
              color="rgb(66, 154, 216)"
              :disabled="
                !valid || item.description == '' || item.description === undefined
              "
              large
              outlined
              @click="saveCompany"
              >Submit</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-dialog v-model="invalidFormDialog" max-width="600">
          <v-card>
            <v-card-title class="font-weight-light">INVALID NEW DATA</v-card-title>
            <v-spacer></v-spacer>
            <v-card-text>
              <v-col class="py-0 my-0">
                <p class="font-weight-light">
                  * Please kindly fill in all required form data!
                </p>
              </v-col>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>

      <!--color dialog-->
      <v-dialog persistent v-model="colorChartDialog" max-width="345">
        <v-card>
          <v-card-title class="font-weight-light text-uppercase"
            >{{ colorSection }} COLOR</v-card-title
          >
          <v-card-text>
            <v-color-picker
              v-model="colorSelected"
              show-swatches
              :mode="colorMode"
            ></v-color-picker>
            <v-select
              v-model="colorMode"
              :items="colorPickerModes"
              style="max-width: 300px"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click.stop="cancelColorChart"
              >Cancel</v-btn
            >
            <v-btn color="green darken-1" text @click="colorChartDialog = false"
              >Done</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <completeDialog
        v-bind:cm_dialog.sync="completeWarning.isShow"
        v-bind:cm_title.sync="completeWarning.title"
        v-bind:cm_color.sync="completeWarning.colorBtn"
        v-bind:cm_text="completeWarning.text"
        @done="closeSuccesDialog"
      ></completeDialog>
    </v-form>
  </div>
</template>

<script>
import completeDialog from "@/components/completeDialog";
import colorButton from "@/components/colorButton";
import { uploadImage } from "@/service/upload/upload";
// import { cleaningData } from "@/helper/cleaningData";
import warnningComponent from "@/components/warningAlert.vue";
import { fetchCompanyById, updateCompany } from "@/service/company/company";
export default {
  components: {
    warnningComponent,
    completeDialog,
    colorButton,
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      valid: true,
      item: {
        id: "",
        appLogo: "",
        title: "",
        description: "",
        systemEmail: "",
        contactEmail: "",
        domainName: "",
        externalAccess: false,
        slugName: "",
        register: {
          canRegister: false,
          loginEmail: false,
          loginGoogle: false,
          loginFacebook: false,
          loginAppleID: false,
        },
        course: {
          courseLimitation: false,
          courseLimit: 0,
        },
        user: {
          userLimitation: false,
          userLimit: 1,
        },
        storage: {
          storageLimitation: false,
          storageLimit: 0,
        },
        keyIcon: "",
        coverImg: "",
        logo: "",
        color: {
          headerColor: "#607D8B",
          footerColor: "#607D8B",
          buttonColor: "#607D8B",
          themeColor: "#607D8B",
        },
        permission: {},
      },
      companyNameRules: [(v) => !!v || "Company Name  is required"],
      descriptionRules: [(v) => !!v || "Company's Description is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      keyIconRules: [(v) => !!v || "Key Icon is required"],
      domainNameRule: [(v) => !!v || "Sub Domain Name is required"],
      imageRules: [
        (v) => !v || v.size < 20000000 || "Image size should be less than 20 MB!",
      ],
      //image file
      logoFile: null,
      logoReady: true,
      imageFile: null,
      coverImgReady: true,
      //alert
      invalidFormDialog: false,
      //warrning
      textWarning: "",
      typeWarning: "",
      showWarnnig: false,
      //customize color
      colorMode: "hsla",
      colorPickerModes: ["hsla", "rgba", "hexa"],
      tmpColor: "#607D8B",
      colorSelected: "#607D8B",
      colorSection: "header",
      colorChartDialog: false,
      completeWarning: {
        isShow: false,
        title: "Successfully Saved",
        text: "The company's detail is successfully saved.",
        colorBtn: "success",
      },
    };
  },
  mounted() {
    this.getCompany();
  },
  computed: {
    headerColor: {
      get() {
        return this.item.color.headerColor;
      },
      set(v) {
        this.item.color.headerColor = v;
      },
    },
    footerColor: {
      get() {
        return this.item.color.footerColor;
      },
      set(v) {
        this.item.color.footerColor = v;
      },
    },
    buttonColor: {
      get() {
        return this.item.color.buttonColor;
      },
      set(v) {
        this.item.color.buttonColor = v;
      },
    },
    overallColor: {
      get() {
        return this.item.color.themeColor;
      },
      set(v) {
        this.item.color.themeColor = v;
      },
    },
  },
  watch: {
    "item.course.courseLimitation": async function (newValue) {
      if (newValue === false) {
        this.item.course.courseLimit = 0;
      }
    },
    "item.user.userLimitation": async function (newValue) {
      if (newValue === false) {
        this.item.user.userLimit = 0;
      }
    },
    "item.storage.storageLimitation": async function (newValue) {
      if (newValue === false) {
        this.item.storage.storageLimit = 0;
      }
    },
    "item.register.canRegister": async function (newValue) {
      if (newValue === false) {
        this.item.register.loginEmail = false;
      } else if (newValue === true) {
        this.item.register.loginEmail = true;
      }
    },
    colorSelected: async function (newValue) {
      switch (this.colorSection) {
        case "header":
          this.headerColor = newValue;
          break;
        case "footer":
          this.footerColor = newValue;
          break;
        case "button":
          this.buttonColor = newValue;
          break;
        default:
          this.overallColor = newValue;
          break;
      }
    },
  },
  methods: {
    async getCompany() {
      let items = await fetchCompanyById({ idcompany: this.id });
      let {
        title,
        description,
        systemEmail,
        contactEmail,
        domainName,
        externalAccess,
        canRegister,
        courseLimit,
        storageLimit,
        userLimit,
        keyIcon,
        coverImg,
        logo,
        headerColor,
        footerColor,
        buttonColor,
        themeColor,
        permission,
        appLogo,
        loginEmail,
        loginGoogle,
        loginFacebook,
        loginAppleID,
        slugName,
      } = items.company;

      this.item.id = this.id;
      this.item.appLogo = appLogo;
      this.item.permission = permission;
      this.item.title = title;
      this.item.description = description;
      this.item.systemEmail = systemEmail;
      this.item.contactEmail = contactEmail;
      this.item.domainName = domainName;
      this.item.externalAccess = externalAccess;
      this.item.register.canRegister = canRegister;
      this.item.register.loginEmail = loginEmail;
      this.item.register.loginGoogle = loginGoogle;
      this.item.register.loginAppleID = loginAppleID;
      this.item.register.loginFacebook = loginFacebook;
      this.item.slugName = slugName;
      this.item.course.courseLimit = courseLimit !== null ? courseLimit : 0;
      this.item.course.courseLimitation = this.item.course.courseLimit > 0 ? true : false;
      this.item.storage.storageLimit = storageLimit !== null ? storageLimit : 0;
      this.item.storage.storageLimitation =
        this.item.storage.storageLimit > 0 ? true : false;
      this.item.user.userLimit = userLimit !== null ? userLimit : 0;
      this.item.user.userLimitation = this.item.user.userLimit > 0 ? true : false;
      this.item.keyIcon = keyIcon ? keyIcon : "";
      this.item.coverImg = coverImg ? coverImg : "";
      this.item.logo = logo ? logo : "";
      this.item.color.headerColor = headerColor ? headerColor : "#607D8B";
      this.item.color.footerColor = footerColor ? footerColor : "#607D8B";
      this.item.color.buttonColor = buttonColor ? buttonColor : "#607D8B";
      this.item.color.themeColor = themeColor ? themeColor : "#607D8B";
    },
    async saveCompany() {
      if (this.$refs.form.validate()) {
        // api upload img
        let logo_url =
          this.logoFile !== null
            ? await uploadImage("company", this.logoFile)
            : this.item.logo;
        let image_url =
          this.imageFile !== null
            ? await uploadImage("company", this.imageFile)
            : this.item.coverImg;

        Promise.all([logo_url, image_url]);

        this.item.logo = logo_url;
        this.item.coverImg = image_url;
        let isValidForm = true;
        if (
          this.item.logo.length < 1 ||
          this.item.coverImg.length < 1 ||
          this.item.color.headerColor.length < 1 ||
          this.item.color.footerColor.length < 1 ||
          this.item.color.buttonColor.length < 1 ||
          this.item.color.themeColor.length < 1
        ) {
          isValidForm = false;
          console.log(`isValid: ${isValidForm}`);
          console.log(`COMPANY LOGO: ${this.item.logo}`);
          console.log(`COVER IMAGE: ${this.item.coverImg}`);
          console.log(`HEADER COLOR: ${this.item.color.headerColor}`);
          console.log(`FOOTER COLOR: ${this.item.color.footerColor}`);
          console.log(`BUTTON COLOR: ${this.item.color.buttonColor}`);
          console.log(`OVERALL COLOR: ${this.item.color.themeColor}`);
        }
        if (isValidForm) {
          let status = await updateCompany(this.item);
          if (status.message == "domain duplicate") {
            this.warnnig("Domain duplicate", "warning");
          } else if (status.code == 403) {
            this.warnnig("กรุณากรอกข้อมูลให้ถูกต้อง", "warning");
          } else {
            this.completeWarning.isShow = true;
          }
        } else {
          this.invalidFormDialog = true;
        }
      }
    },
    async previewLogo(event) {
      let file = event.target.files[0];
      this.logoFile = file;
      this.item.logo = URL.createObjectURL(file);
      this.logoReady = true;
    },
    async previewCoverImg(event) {
      let file = event.target.files[0];
      this.imageFile = file;
      this.item.coverImg = URL.createObjectURL(file);
      this.coverImgReady = true;
    },
    showCompanyList() {
      this.$router.push({
        path: "/company",
      });
    },
    showColorChart(section) {
      switch (section) {
        case "header":
          this.tmpColor = this.headerColor;
          break;
        case "footer":
          this.tmpColor = this.footerColor;
          break;
        case "button":
          this.tmpColor = this.buttonColor;
          break;
        default:
          this.tmpColor = this.overallColor;
          break;
      }
      this.colorSection = section;
      this.colorSelected = this.tmpColor;
      this.colorChartDialog = true;
    },
    cancelColorChart() {
      alert(this.colorSection);
      switch (this.colorSection) {
        case "header":
          this.item.color.headerColor = this.tmpColor;
          break;
        case "footer":
          this.item.color.footerColor = this.tmpColor;
          break;
        case "button":
          this.item.color.buttonColor = this.tmpColor;
          break;
        default:
          this.item.color.overallColor = this.tmpColor;
          break;
      }
      this.colorChartDialog = false;
    },
    warnnig(text, type) {
      (this.textWarning = text), (this.typeWarning = type), (this.showWarnnig = true);
      setInterval(() => {
        this.showWarnnig = false;
      }, 5000);
    },
    closeSuccesDialog(value) {
      this.completeWarning.isShow = value;
    },
  },
};
</script>

<style scoped>
.text-right {
  text-align: right;
}

.editor {
  height: 200px;
  margin-bottom: 50px;
  background: white;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  align-self: center;
  position: absolute;
  opacity: 0.5;
  height: 20%;
  width: 100%;
}
.border-card {
  border: 1px dashed #80808040 !important;
  /* -webkit-box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important; */
  /* box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important; */
}
.image-preview {
  min-height: 300px;
  border: 1px dashed rgba(0, 0, 0, 0.15) !important;
  background: #ebedf0;
}

/*btn-upload image*/
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 170px !important;
}

.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.upload-btn-wrapper input[type="file"]:hover {
  cursor: pointer;
}

.text-field-border {
  border: 1px solid;
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}
</style>
<style>
.input-number {
  height: 45px !important;
}

.input-number > .v-input__control > .v-input__slot {
  min-height: 45px !important;
}

.input-number > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  text-align: right;
}
.editor .ql-editor {
  background-color: white;
}
</style>
